var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rect',{attrs:{"id":"fog","width":"100%","height":"100%","fill":"white","opacity":"1"}})}
var staticRenderFns = []

export { render, staticRenderFns }